import React from 'react';

import { Banner } from '@neptune/shared/venus-ui';

import ContactSales from 'components/contact-sales/ContactSales';

export const InvitationsLimitReachedNotice = () => {
  return (
    <Banner.Warning>
      <span>
        You have reached limit of available invitations. If you want to invite more members to your
        workspace, you can <ContactSales>contact sales</ContactSales>.
      </span>
    </Banner.Warning>
  );
};
